export default __webpack_public_path__ + "src/docs/packages/lush-private-game-lodge.pdf";